import React, { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { getEntity } from './user.reducer';
import { connect } from 'react-redux';
import DetailsPage, { DetailsStateAndDispatchProps } from "layouts/page-wraper/details-page";
import { RootState } from "reducers";
import ProDescriptions from "@ant-design/pro-descriptions";
import { ActiveUser } from "model/customerCore/active-user.model";

export interface ActiveUserDetailsProps extends DetailsStateAndDispatchProps<ActiveUser>,
  RouteComponentProps, StateProps, DispatchProps {
}

const ActiveUserDetails: FC<ActiveUserDetailsProps> = (props: any) => {

  return (
    <DetailsPage<ActiveUser>
      title='消息详情'
      hideEdit={true}
      {...props}
    >
      <ProDescriptions<ActiveUser>
        column={1}
        columns={props.columns}
        dataSource={props.entity}
      >
      </ProDescriptions>
    </DetailsPage>);
};

const mapStateToProps = ({ activeUser }: RootState) => ({
  entity: activeUser.entity,
});

const mapDispatchToProps = {
  getEntity
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(ActiveUserDetails);
